import React from 'react';
import {Row, Col, Table } from 'reactstrap';
import CodeBlock from '../CodeBlock';

function TestUrlSection() {
    return (
        <section id="federated-search-API-test-URLs">
            <Row>
                <Col>
                    <h2>Federated Search API Test URLs</h2>
                    <p>These endpoints are purely for integration and will return test data.</p>
                    <Table bordered>
                        <thead>
                            <tr>
                                <th>Site</th>
                                <th>Base API URL</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>TotalJobs</td>
                                <td>
                                    <CodeBlock language="json">https://recruiter.totaljobs.tjgtest.com/CandidateSearchApi</CodeBlock>
                                </td>
                            </tr>
                            <tr>
                                <td>Caterer</td>
                                <td>
                                    <CodeBlock CodeBlock>https://recruiter.caterer.tjgtest.com/CandidateSearchApi</CodeBlock>
                                </td>
                            </tr>
                            <tr>
                                <td>Caterer Global</td>
                                <td>
                                    <CodeBlock CodeBlock>https://recruiter.catererglobal.tjgtest.com/CandidateSearchApi</CodeBlock>
                                </td>
                            </tr>
                            <tr>
                                <td>CWJobs</td>
                                <td>
                                    <CodeBlock CodeBlock>https://recruiter.cwjobs.tjgtest.com/CandidateSearchApi</CodeBlock>
                                </td>
                            </tr>
                            <tr>
                                <td>RetailChoice</td>
                                <td>
                                    <CodeBlock CodeBlock>https://recruiter.retailchoice.tjgtest.com/CandidateSearchApi</CodeBlock>
                                </td>
                            </tr>
                            <tr>
                                <td>CareerStructure</td>
                                <td>
                                    <CodeBlock CodeBlock>https://recruiter.careerstructure.tjgtest.com/CandidateSearchApi</CodeBlock>
                                </td>
                            </tr>
                            <tr>
                                <td>Jobsite</td>
                                <td>
                                    <CodeBlock CodeBlock>https://recruiter.jobsite.tjgtest.com/CandidateSearchApi</CodeBlock>
                                </td>
                            </tr>
                            <tr>
                                <td>Cityjobs</td>
                                <td>
                                    <CodeBlock CodeBlock>https://recruiter.cityjobs.tjgtest.com/CandidateSearchApi</CodeBlock>
                                </td>
                            </tr>
                            <tr>
                                <td>eMedCareers</td>
                                <td>
                                    <CodeBlock CodeBlock>https://recruiter.emedcareers.tjgtest.com/CandidateSearchApi</CodeBlock>
                                </td>
                            </tr>
                            <tr>
                                <td>Just Engineers</td>
                                <td>
                                    <CodeBlock CodeBlock>https://recruiter.justengineers.tjgtest.com/CandidateSearchApi</CodeBlock>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </section>
    )
}

export default TestUrlSection
